const e = [
  { i: "-", t: "(unbekannt)" },
  { i: "N", t: "Neufahrzeug" },
  { i: "U", t: "Gebrauchtfahrzeug" },
  { i: "D", t: "Vorführfahrzeug" },
  { i: "T", t: "Tageszulassung" },
  { i: "M", t: "Mietfahrzeug" },
  { i: "S", t: "Sonderfahrzeug" }
];
export {
  e as default
};
